import "Data/EventCollection";
import "System/Command";

/** @namespace System */
NS("System");

/**
 * @class
 * @extends Data.EventCollection
 */
System.CommandsStack = Class(Data.EventCollection, /** @lends System.CommandsStack.prototype */ {
    /**
     * @type {number}
     */
    pointer: 0,
    /**
     * Clears commands stack and resets pointer
     * @returns {System.CommandsStack}
     */
    clear() {
        this.pointer = 0;
        return this.ParentCall();
    },
    /**
     * @param {number} index
     * @param {System.Command|Object} cmd
     * @param {boolean} [truncate=false]
     * @returns {System.Command}
     */
    insertAt(index, cmd, truncate) {
        assert(_.isObject(cmd), "Command must be of type System.Command or an Object", InvalidArgumentError);

        if (!Class.Is(cmd, System.Command)) {
            cmd = new System.Command(cmd);
        }

        cmd.run();

        return this.Parent(index, cmd, truncate);
    },
    /**
     * @param {System.Command} cmd
     * @returns {System.CommandsStack}
     */
    push(cmd) {
        this.insertAt(this.pointer, cmd, true);
        this.pointer = this.length;

        return this;
    },
    /**
     * @protected
     */
    update_() {
        this.ParentCall();

        if (this.pointer > this.length) { // for remove
            this.pointer = this.length;
        }
    },
    /**
     * @param {number} pos
     * @returns {System.CommandsStack}
     */
    stepTo(pos) {
        assert(pos >= 0 && pos <= this.length, `Position ${pos} is out of bounds of the commands stack: [0, ${this.length}]`, RangeError);

        switch (true) {
            // step forward
            case pos > this.pointer:
                _.each(_.range(this.pointer, pos), (i) => {
                    this.items_[i].run();
                    ++this.pointer;
                });
                break;
                // step back
            case pos < this.pointer:
                _.each(_.range(this.pointer, pos, -1), (i) => {
                    this.items_[i - 1].undo();
                    --this.pointer;
                });
                break;
        }

        return this;
    },
    /**
     * Step back in commands history
     * @returns {System.CommandsStack}
     */
    undo() {
        return this.stepTo(this.pointer - 1);
    },
    /**
     * Step forward in commands history
     * @returns {System.CommandsStack}
     */
    redo() {
        return this.stepTo(this.pointer + 1);
    },
    /**
     * @returns {boolean}
     */
    isStart() {
        return this.pointer === 0;
    },
    /**
     * @returns {boolean}
     */
    isEnd() {
        return this.pointer === this.length;
    }
});
